import HtmlView from "@/components/views/HtmlView";
import { DescriptionsProps } from "antd";
import { t } from "i18next";
import { Contract } from "../../types";

export const createNoteDescriptionItem = (contract: Contract): NonNullable<DescriptionsProps["items"]>[number] => ({
  label: t("contract.attrs.note"),
  children: contract.note ? (
    <div style={{ minWidth: "100%", width: 0 }}>
      <HtmlView value={contract.note} />
    </div>
  ) : undefined,
  span: 3,
});
